export default __webpack_public_path__ + "static/media/Hospital Licenses.7a04a785.png";